/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/prop-types */
import React from "react";

import Grid from "@mui/material/Grid";

const TermSheetConfigHeader = (props) => {
  const { termSheetConfig = {} } = props;
  const { header } = termSheetConfig ?? {};

  return (
    <Grid container className={header?.className || ""}>
      <Grid item xs={8}>
        <span
          style={{
            color: "white",
            justifyContent: "start",
            display: "flex",
            alignItems: "center"
          }}
        >
          {header?.originatorInfo}
        </span>
      </Grid>
      <Grid
        item
        xs={4}
        sx={{ display: "flex", justifyContent: "end", cursor: "pointer" }}
      >
        <img
          alt='close-icon.svg'
          src={header?.closeIcon}
          onClick={() => {
            return props?.onClose();
          }}
          title='Close'
        />
      </Grid>
    </Grid>
  );
};

export default TermSheetConfigHeader;
